import {ConnectionInfo} from '@core/api/back';

export type CopyTable = {
    wellId: number;
    tableName: string[];
};

export type Contract = {
    id: number;
    name: string;
    value: string;
};

export type Project = {
    id: number;
    name: string;
    value: string;
};

export type WellEntity = {
    id: number;
    field: string; // Месторождение
    fieldId?: number; // Месторождение
    fieldTitle?: string; // Месторождение
    name: string; // Скважина
    pad: string; // Куст
    padTitle?: string; // Куст
    padId?: number; // Куст
    wellprofileType: string | null; // Тип скважины
    zoneId: string; // Часовой пояс
    status: WellStatus | null; // Статус
    extendedStatus?: string; // Подробный статус
    itemOrder: string | null; // Порядковый номер
    crsType: string | null; // Система координат
    globalCoordinates: {
        latitude: number | null;
        longitude: number | null;
    };
    wellheadCoordinatesOffsetToTheNorth: number | null; // Смещение на север
    wellheadCoordinatesOffsetToTheEast: number | null; // Смещение на запад
    copyTableInfo?: CopyTable[];
    needCopyTables?: boolean;
    project: Project | null; // Проект
    projectId?: number | null;
    projectTitle?: string | null;
    contract: Contract | null; // Контракт
    contractId?: number | null; // Контракт
    contractTitle?: string | null; // Контракт
    altitude: number | null; // Альтитуда
    verticalAzimuth: number | null; // Азимут вертикальной плоскости
    totalCorrection: number | null; // Суммарная поправка
    connections?: ConnectionInfo[];
    connectionId?: string;
    connectionIdWitsml?: number;
    connectionIdSkpb?: number;
    connectionIdAkb?: number;
    isIntroductory: boolean; // Вводная скважина
    disabled?: boolean; // Заблокирована
    wellEndingType: string | null; // Тип конца скважины
    wellCategory: string | null; // Категория скважины
    wellPurpose: string | null; // Цель скважины
    wellboreContractionList: string[] | null; // Список стволов
};

export type WellEntityToUpdate = {
    id: number;
    field: string;
    name: string;
    pad: string;
    wellprofileType: string | null;
    status: string | null;
    copyTableInfo?: CopyTable[];
    needCopyTables?: boolean;
    projectId: number | null;
    contractId: number | null;
    itemOrder?: number;
    crsType: string | null;
    wellheadCoordinatesOffsetToTheNorth?: number;
    wellheadCoordinatesOffsetToTheEast?: number;
    altitude?: number;
    verticalAzimuth?: number;
    totalCorrection?: number;
    isIntroductory: boolean;
    zoneId: string;
    wellEndingType: string | null;
    wellCategory: string | null;
    wellPurpose: string | null;
};

export type WellEntityWithoutId = Omit<WellEntity, 'id'> & {
    id?: number;
};

export type WellEntityToUpdateWithoutId = Omit<WellEntityToUpdate, 'id'> & {
    id?: number;
};

export type WellsTreePad = {
    padId: number;
    padTitle: string;
    fieldId: number;
    wells: WellEntity[];
};

export type WellsTreeField = {
    fieldId: number;
    fieldTitle: string;
    pads: WellsTreePad[];
};

export enum CompletionStatusFilter {
    ALL = 'ALL',
    ONLY_COMPLETED = 'ONLY_COMPLETED',
    ONLY_ACTIVE = 'ONLY_ACTIVE',
}

export enum WellStatus {
    Planned = 'Планируемая',
    VMR = 'ВМР',
    Drilling = 'Бурение',
    Development = 'Освоение',
    Conservation = 'Консервация',
    Moving = 'Передвижка',
    Inactive = 'Неактивная',
    Completed = 'Завершена',
    WaitForDevelopment = 'Ожидание освоения',
    SuspendedDueToAdvancedDrilling = 'Приостановка при опережающем бурении',
}

export enum WellConstructionStage {
    VMR = 'ВМР',
    Drilling = 'Бурение',
    Fastening = 'Крепление',
    StopWorksDueToWaitForDevelopment = 'Приостановка работ на период ожидания освоения',
    Development = 'Освоение',
    Moving = 'Передвижка',
    Testing = 'Испытания',
    PreparationForDrilling = 'Подготовительные работы к бурению',
}
